export var GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS = 'getclasspass';
export var BASETRIAL_PROMOTION_ALIAS = 'basetrial';